import { z } from 'zod'

import type { OrderSubTabKey, OrderTabKey } from './order-tabs'

const tabKeys = ['unpaid', 'billed', 'processing', 'shipped', 'done'] as const satisfies readonly OrderTabKey[]
const subTabKeys = ['all', 'awaiting-payment'] as const satisfies readonly OrderSubTabKey[]

/**
 * Soft-fallback on invalid tab/subTab (e.g. stale post-login redirect URLs).
 * `.default()` only covers missing keys; `.catch()` also recovers bad values so
 * validateSearch does not throw and block the detail-group loader.
 */
export const detailGroupSearchSchema = z.object({
  tab: z.enum(tabKeys).catch('unpaid'),
  subTab: z.enum(subTabKeys).catch('all'),
})

export type DetailGroupSearch = z.infer<typeof detailGroupSearchSchema>

export const defaultDetailGroupSearch = detailGroupSearchSchema.parse({})
